import { ThemeProperties } from '../../core';

export interface SpinnerTheme {
	xSmallSize: string;
	smallSize: string;
	mediumSize: string;
	largeSize: string;
}

export const theme = new ThemeProperties('spinner');
